import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { withMetrics } from '@catalogo/core-metrics';
import compose from 'lodash/fp/compose';
import { withCustomer } from '@catalogo/core-connect/customer';
import { LikeAnswer, DislikeAnswer } from '..';
import { feedbackHelper } from '../helpers';

export const withFeedback = Component => ({ evaluation, customer, history, questionId, answerId, dispatchMetrics }) => {
  const [action, setAction] = useState('');
  const [like, setLike] = useState(false);
  const [dislike, setDislike] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [dislikeCount, setDisLikeCount] = useState(0);
  const [metricsLabel, setMetricsLabel] = useState('');

  const feedbackArgs = [questionId, answerId, action, LikeAnswer(), DislikeAnswer()];

  const handleLike = () => {
    setLikeCount(like ? likeCount - 1 : likeCount + 1);
    setLike(!like);
    return dislike ? handleDislike() : false;
  };

  const handleDislike = () => {
    setDisLikeCount(dislike ? dislikeCount - 1 : dislikeCount + 1);
    setDislike(!dislike);
    return like ? handleLike() : false;
  };

  const handleRequest = async () => {
    const feedbackResponse = await feedbackHelper(feedbackArgs);

    if (feedbackResponse === null) {
      action === 'like' ? handleLike() : handleDislike();
    }

    return setAction('');
  };
  const handleClick = (rating, feedback) => {
    if (!customer?.id) {
      return history.push('#modal-login');
    }

    setAction(rating);

    const metric = feedback ? `remove ${rating}` : rating;
    setMetricsLabel(metric);
  };

  useEffect(() => {
    if (action) {
      dispatchMetrics('event:track', {
        category: 'product',
        action: `Q&A - Feedback`,
        label: metricsLabel,
      });

      handleRequest();
    }
  }, [action]);
  useEffect(() => {
    setDislike(evaluation?.rating === 'DISLIKE');
    setLike(evaluation?.rating === 'LIKE');
    setLikeCount(evaluation?.like);
    setDisLikeCount(evaluation?.dislike);
  }, []);

  const feedback = { like, dislike, likeCount, dislikeCount };
  return <Component evaluation={evaluation} feedback={feedback} handleClick={handleClick} />;
};

export default compose(withCustomer, withMetrics, withRouter, withFeedback);
